import axios from "axios";
import config from "../../config/config";
import axiosClient from "../shared/api/axios-client";
import {
  LevelTestSession,
} from "./studentLevelTest.interfaces";
import * as mocks from "./studentLevelTest.mocks";

const API_URL = `${config.apiBaseUrl}/admin/students`;

// API functions (para uso futuro quando backend estiver disponível)
const apiGetStudentLevelTestSession = async (
  studentId: string
): Promise<LevelTestSession | null> => {
  try {
    const response = await axiosClient.get<LevelTestSession | null>(
      `${API_URL}/${studentId}/level-test-session`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 404) {
        return null; // Não há sessão
      }
      console.error("Axios error during get level test session:", error.message);
    } else {
      console.error("Unexpected error during get level test session:", error);
    }
    throw error;
  }
};

const apiDeleteStudentLevelTestSession = async (
  studentId: string
): Promise<void> => {
  try {
    await axiosClient.delete(`${API_URL}/${studentId}/level-test-session`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error during delete level test session:", error.message);
    } else {
      console.error("Unexpected error during delete level test session:", error);
    }
    throw error;
  }
};

const apiGetLevelTestSessionDetails = async (
  sessionId: string
): Promise<LevelTestSession> => {
  try {
    const response = await axiosClient.get<LevelTestSession>(
      `${config.apiBaseUrl}/level-test-sessions/${sessionId}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error during get level test session details:", error.message);
    } else {
      console.error("Unexpected error during get level test session details:", error);
    }
    throw error;
  }
};

// Exported functions - usando config.useRealApi para alternar entre API e mock
export const getStudentLevelTestSession = async (
  studentId: string
): Promise<LevelTestSession | null> => {
  return config.useRealApi
    ? apiGetStudentLevelTestSession(studentId)
    : mocks.getStudentLevelTestSession(studentId);
};

export const deleteStudentLevelTestSession = async (
  studentId: string
): Promise<void> => {
  return config.useRealApi
    ? apiDeleteStudentLevelTestSession(studentId)
    : mocks.deleteStudentLevelTestSession(studentId);
};

export const getLevelTestSessionDetails = async (
  sessionId: string
): Promise<LevelTestSession> => {
  return config.useRealApi
    ? apiGetLevelTestSessionDetails(sessionId)
    : mocks.getLevelTestSessionDetails(sessionId);
};